import { compareRows } from "../data";
import SectionHead from "./SectionHead";

export default function Compare() {
  return (
    <section id="compare" className="bg-background-50 py-14 md:py-20">
      <div className="wrap">
        <SectionHead
          no="03"
          title="各种说法，摆一起对比"
          desc="同一个「吃瓜91」，在不同人嘴里解读可能不一样。我们把它常见的两种讲法并排比一比，你按自己顺眼的理解用就行。"
          tone="primary"
        />

        <div className="mt-10 flex flex-col gap-4">
          {compareRows.map((row) => (
            <div
              key={row.claim}
              className="grid gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:grid-cols-[0.7fr_1fr_1fr_1fr] md:items-center"
            >
              <div className="eyebrow text-sm font-bold text-foreground-900">{row.claim}</div>
              <div className="flex items-start gap-2 text-sm text-foreground-700">
                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-vip-crown-line h-3 w-3 flex items-center justify-center" />
                </span>
                {row.sideA}
              </div>
              <div className="flex items-start gap-2 text-sm text-foreground-700">
                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-leaf-line h-3 w-3 flex items-center justify-center" />
                </span>
                {row.sideB}
              </div>
              <div className="rounded-md bg-secondary-100 px-3 py-2 text-xs leading-relaxed text-secondary-900">
                {row.take}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}